import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Builder from "./views/Builder.vue";
import SRPBuilder from '@/views/SRPBuilder.vue';
import Preview from "./views/Preview.vue";
import SRPPreview from '@/views/SRPPreview.vue';

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/builder",
      name: "Builder",
      component: Builder
    },
    {
      path: '/srp-builder',
      name: 'SRPBuilder',
      component: SRPBuilder
    },
    {
      path: "/preview",
      name: "Preview",
      component: Preview
    },
    {
      path: '/srp-preview',
      name: 'SRPPreview',
      component: SRPPreview
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
